import {LocationOffering} from './side-nav.model';

export class LandlordPropertyModel {
  uuid!: string;
  locationName!: string;
  locationCode!: string;
  bannerImage?: string;
  tileImage?: string;
  locationAddress!: LocationAddress;
  locationOfferings?: LocationOffering[];
}


export interface LandlordPropertiesResponse {
  content: LandlordPropertyModel[]
}

export interface LocationAddress {
  uuid: string;
  landlordUuid: string;
  locationUuid: string;
  placeId: string,
  placeName: string;
  formattedAddress: string;
}

export interface PropertyLocationOffering {

}
